<template>
  <div>
    <v-dialog v-model="loading" persistent max-width="300">
      <v-card color="primary" dark>
        <v-card-text class="d-flex flex-column align-center">
          <v-progress-circular indeterminate color="white" size="40" class="mb-4" />
          <span>Aguarde...</span>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-list-group prepend-icon="mdi-badge-account">
      <template v-slot:activator>
        <v-list-item-title>ADMINISTRATIVO</v-list-item-title>
      </template>

      <v-list-item v-for="menu in dadosmenu" :key="menu.action" @click="acao(menu.action)">
        <v-list-item-icon>
          <v-icon :color="menu.colorIcon">{{ menu.icon }}</v-icon>
        </v-list-item-icon>
        <v-list-item-title>{{ menu.title }}</v-list-item-title>
      </v-list-item>
    </v-list-group>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import filtros from "@/libs/filters";

export default {
  name: "MenuServidor",
  data: () => ({
    loading: false,
    menus: [
      { title: "Questionarios", icon: "mdi-format-list-checks", action: 1, colorIcon: "orange accent-4" },
      { title: "Perfil Usuario", icon: "mdi-face-man-profile", action: 2, colorIcon: "blue" },
      { title: "Estagiários Magistério", icon: "mdi-school", action: 3, colorIcon: "teal" },
      { title: "CPF Comissão", icon: "mdi-card-account-details-outline", action: 4, colorIcon: "indigo" },
      { title: "Respostas por Instituição", icon: "mdi-clipboard-text-outline", action: 5, colorIcon: "deep-purple" },
      { title: "Devolutiva Avaliação", icon: "mdi-file-pdf-box", action: 6, colorIcon: "red darken-2" },
      { title: "Relatório Nota Final", icon: "mdi-chart-bar", action: 7, colorIcon: "green darken-2" },
    ],
  }),
  components: {},
  filters: filtros,
  computed: {
    ...mapGetters({
      processos: "config/getProcessos",
    }),
    dadosLogado() {
      return this.$store.getters["config/getUsuarioLogado"];
    },
    dadosmenu() {
      return this.menus;
    },
    processoInscricao() {
      const pro = this.processos.find((p) => p.id == 1);
      return pro;
    },
  },
  methods: {
    async acao(opcao) {
      switch (opcao) {
        case 1:
          this.$router.push("/selecionar-instrumento-questionario");
          break;
        case 2:
          console.log("action 2");
          break;
        case 3:
          this.$router.push("/estagiarios-magisterio");
          break;
        case 4:
          this.$router.push("/cpf-comissao");
          break;
        case 5:
          this.$router.push("/respostas-por-instituicao");
          break;
        case 6:
          this.$router.push("/devolutiva-avaliacao");
          break;
        case 7:
          this.$router.push("/relatorio-nota-final");
          break;
      }
      this.$store.commit("config/setSidebarOpen", false);
    },
  },
  mounted: function () {
    // Verifica se existe processo com id == 1
  },
};
</script>
